import * as Common from '@/agiles/common';

  export class WorkflowPermission extends Common.ObjectBase{
        constructor(){
        super('WorkflowPermission');
        this.binders.workflow = new Common.ModelBinder(Common.Workflow);
    } 
      public id: number=0;   
      public workflowId: number;
      public workflowStateId: number; //Workflow.actionsのindex+1を保持
      public userId: string;
      public groupId: string;
      public workflow: Common.Workflow;
      public getWorkflowStatusList2():Common.BindItem[]{
        // if (this.workflow) return this.workflow.getList2();
        // else return new Array<Common.BindItem>();
        const result = new Array();
        if (this.workflow)
        {
          var sectionId = this.sectionId;
          this.workflow.controller.systemStates.filter(state=> state.sectionId ==sectionId).forEach(state =>{
            //開始ステータスは割当てられるようにする
            // if ((state.type & Common.StateTypes.EntryStatus)  != Common.StateTypes.EntryStatus && (state.type & Common.StateTypes.ExitStatus)  != Common.StateTypes.ExitStatus)
            if ((state.type & Common.StateTypes.ExitStatus)  != Common.StateTypes.ExitStatus)            
            result.push(new Common.BindItem(state.workflowStateId, state.name))});
          this.workflow.userStates.filter(state=> state.sectionId ==sectionId).forEach(state => result.push(new Common.BindItem(state.workflowStateId, state.name)));
        }

        return result;        
      }      

      public get sectionId(): number{
        if (this.workflow && this.workflowStateId != null) 
          return this.workflow.getState(this.workflowStateId).sectionId;
        else 
          return this._sectionId;           
      }

      public set sectionId(value:number)
      {
          this._sectionId = value;
          this.workflowStateId = null;
      }

      private _sectionId:number = null;
      public get sectionName():string{
        if (this.workflow) 
          return this.workflow.controller.sections.find(sec =>sec.value == this.sectionId).text;
        else 
          return ''; 
      }      
      public getSectionList() {
        if (this.workflow) return this.workflow.controller.sections;
        else return new Array();
      }      
  }
  
export class WorkflowPermissionQuery extends Common.LoadQuery {
  constructor() {
    super('WorkflowPermissionQuery', WorkflowPermission);
    this.sort = 'workflow';
  }
  public workflow: Common.Workflow;  
}
export class UserWorkflowPermissionQuery extends Common.Query {
    constructor(){
        super('UserWorkflowPermissionQuery', new Common.ModelBinder(Common.WorkflowPermission,true))
    }
}